(function (ng, app) {

    Leaderboard2Controller.$inject = ["$mdDialog", "homeApi", "$window", "$scope"];
    app.controller("Leaderboard2Controller", Leaderboard2Controller);
    function Leaderboard2Controller($mdDialog, homeApi, $window, $scope) {
        var $ctrl = this;

        var downloadIncrement = 0;
        ng.extend($ctrl,
            {
                UI: {
                    reverseSort: true,
                    thing: false,
                },
                subCategories: ['Overall', 'Annuity', 'Life', 'Long-Term Care'],
                activeSubCat: 'Overall',
                close: close,
                toggleSort: toggleSort,
                evalSortClasses: evalSortClasses,
                downloadFile: downloadFile,
                leaderboardFilter: leaderboardFilter
            });

        function close($event) {
            $mdDialog.hide($event);
        }

        function toggleSort(name) {
            if ($ctrl.UI.orderByField === name) {
                $ctrl.UI.reverseSort = !$ctrl.UI.reverseSort;
            } else {
                $ctrl.UI.orderByField = name;
            }
        }

        function evalSortClasses(name) {
            var obj = {
                "fa-sort": $ctrl.UI.orderByField !== name,
                "fa-caret-down": $ctrl.UI.orderByField === name && $ctrl.UI.reverseSort,
                "fa-caret-up": $ctrl.UI.orderByField === name && !$ctrl.UI.reverseSort
            };

            return obj;
        }

        function downloadFile() {
            return homeApi.exportMarketingDollars().then(function (data) {

                var f = document.createElement("a");
                f.id = "tmpDownload-" + ++downloadIncrement;
                document.body.appendChild(f);
                f.style = "display: none";

                var fUrl = window.URL.createObjectURL(data);
                f.href = fUrl;
                f.download = "MarketingDollars.xlsx";
                f.click();

                setTimeout(function () {
                    var el = document.getElementById(f.id);
                    document.body.removeChild(el);
                    window.URL.revokeObjectURL(fUrl);
                },
                    100);
            });
        }

        function leaderboardFilter(isGroup, activeSubCat) {
            return function (leaderboard) {
                return isGroup ? leaderboard.Name.includes('Office') && leaderboard.Name.includes(activeSubCat) : !leaderboard.Name.includes('Office') && leaderboard.Name.includes(activeSubCat);
            };
        }
        $ctrl.$onInit = function () {
            $ctrl.filterByGroup = false;
        };
    }
})(window.angular, window.app); //jshint ignore:line